import mergeDeep from 'deepmerge';

class PacosConfig {
    constructor(options) {
        this._options = options;
    }

    get options() {
        return this._options;
    }

    set options(options) {
        this._options = mergeDeep(this._options, options);
    }

    getOptionValue(propValue, option) {
        return propValue !== null ? propValue : this._options[option];
    }
}

const config = new PacosConfig({
    inlineLabel: true,
    svgSpritePath: '/svg/sprite-symbol.svg',
    prefix: 'P',
    precision: 2,
    currency: 'EUR',
    currencyDisplayKey: 'symbol',
    currencySelectDisplayKey: 'label',
    currencies: [
        {
            entity: '&euro;',
            label: 'EUR',
            symbol: '€',
            value: 'EUR',
        },
        {
            entity: 'US&dollar;',
            label: 'USD',
            symbol: 'US$',
            value: 'USD',
        },
    ],
});

export default config;
